export var buildDatasourceAdf = function buildDatasourceAdf(datasource, url) {
  return {
    type: 'blockCard',
    attrs: {
      url: url,
      datasource: datasource
    }
  };
};